import {
  setLoader,
  unSetLoader,
  setErrorMessage,
} from "store/actions/appActions";
import axios from "axios";
import { billing } from "store/requests";

export const getIllnessDetails = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/getIllnessDetails",
        payload,
        addUserName: true,
      });
      return data["success"][0];
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    }
  };
};

export const addIllnessDetails = (payload) => {
  return async (dispatch) => {
    try {
      let { data } = await billing({
        url: "/addIllnessDetails",
        payload,
        addUserName: true,
      });
      return data;
    } catch (error) {
      dispatch(setErrorMessage(error?.response?.data?.error || error.message));
    } finally {
      dispatch(unSetLoader());
    }
  };
};

export const updateIllnessDetails = (payload, source) => {
  return async (dispatch) => {
    try {
      dispatch(setLoader());
      let { data } = await billing({
        url: "/updateIllnessDetails",
        payload,
        data: { cancelToken: source ? source.token : null },
      });
      return data;
    } catch (error) {
      if (!axios.isCancel(error)) {
        dispatch(
          setErrorMessage(error?.response?.data?.error || error.message)
        );
      }
    } finally {
      dispatch(unSetLoader());
    }
  };
};
